import React, { useEffect, useState } from 'react'
import { GetStaticProps, InferGetStaticPropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Header from '../header'
import Footer from '../footer'
import { useRouter } from 'next/router';
import Demo from '@/components/demo';
import PageSeo from '@/components/seo/PageSeo';

const DemoPages = (_props: InferGetStaticPropsType<typeof getStaticProps>) => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { type } = router.query;
  const safeType = type === "agent" || type === "portal" ? type : "portal";

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1300) {
        router.replace("/");
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [router]);

  return (
    <>
      <PageSeo
        title={`Stoneity ${safeType === "agent" ? "Agent" : "Portal"} Demo`}
        description={safeType === "agent"
          ? "Explore the Stoneity Agent demo experience and preview automated workflows, AI-assisted actions, and guided product interactions."
          : "Explore the Stoneity Portal demo experience and preview the self-service portal, request flows, and support journeys."
        }
        locale={router.locale}
        keywords={safeType === "agent"
          ? "Stoneity agent demo, AI agent demo, workflow automation demo"
          : "Stoneity portal demo, self service portal demo, service portal demo"
        }
      />
      <Header />
      <div style={{ marginBlock: "50px" }}>
        <Demo
          t={t}
          enum={safeType}
        />
      </div >
      <Footer />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale || 'en', ['common'])),
  },
});

export default DemoPages;
